const Facebook = () => {
    return (
        <svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.76922 3.99998H11.5384C11.7933 3.99998 12 3.7761 12 3.49996V0.499968C12 0.223875 11.7933 0 11.5384 0H8.76922C5.9666 0.00332812 3.69536 2.46379 3.69233 5.49997V8.99998H0.461552C0.206653 8.99998 0 9.22386 0 9.5V12.5C0 12.7761 0.206653 13 0.461552 13H3.69233V23.5C3.69233 23.7761 3.89898 24 4.15388 24H6.9231C7.178 24 7.38466 23.7761 7.38466 23.5V13H10.6154C10.814 12.9999 10.9902 12.8621 11.053 12.658L11.976 9.65801C12.0566 9.39603 11.9258 9.1129 11.684 9.02562C11.6371 9.0087 11.5879 9.00003 11.5385 8.99998H7.38466V5.49997C7.38461 4.67155 8.00453 3.99998 8.76922 3.99998Z" fill="white" />
        </svg>
    );
};

export default Facebook;
